export default "/img/v12-0-0_fig5.4efe17d04f0b72f47e2ed8063a0f1350.png";